export default __webpack_public_path__ + "static/media/INFINITYPADDARK.79232b6b.png";